import { clean as removeDiacritics } from "diacritic";
import clsx from "clsx";
import theme from "../components/_themes/_GUS";

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
var specialCharsRegex = /[.*+?^${}()|[\]\\]/g;

function escapeRegexCharacters(str) {
    return str.replace(specialCharsRegex, "\\$&");
}

export const Match = (text, query, anyMatch) => {
    text = removeDiacritics(text);
    query = removeDiacritics(query);

    return query
        .trim()
        .split("     ")
        .filter((word) => word.length > 0)
        .reduce(function (result, word) {
            var wordLen = word.length;
            var regex = new RegExp(escapeRegexCharacters(word), "gmi");
            var index = anyMatch
                ? text.toLowerCase().search(escapeRegexCharacters(word).toLowerCase())
                : text.search(regex);

            if (index > -1) {
                result.push([index, index + wordLen]);
                text = text.slice(0, index) + new Array(wordLen + 1).join(" ") + text.slice(index + wordLen);
            }

            return result;
        }, [])
        .sort((match1, match2) => match1[0] - match2[0]);
};

export const Parse = (text, matches) => {
    var result = [];

    if (matches.length === 0) {
        result.push({
            text: text,
            highlight: false,
        });
    } else {
        if (matches[0][0] > 0) {
            result.push({
                text: text.slice(0, matches[0][0]),
                highlight: false,
            });
        }
    }

    matches.forEach(function (match, i) {
        var startIndex = match[0];
        var endIndex = match[1];

        result.push({
            text: text.slice(startIndex, endIndex),
            highlight: true,
        });

        if (i === matches.length - 1) {
            if (endIndex < text.length) {
                result.push({
                    text: text.slice(endIndex, text.length),
                    highlight: false,
                });
            }
        } else if (endIndex < matches[i + 1][0]) {
            result.push({
                text: text.slice(endIndex, matches[i + 1][0]),
                highlight: false,
            });
        }
    });

    return result;
};

export const Highlight = ({ text, search, classes }) => {
    const styles = {
        unHighlighted: {},
        highlighted: {
            background: theme.palette.primary.main,
            // backgroundColor: "#1977bd",
            color: "#fff",
        },
    };

    const matches = Match(text, search, false);

    const parts = Parse(text, matches);

    return (
        <>
            {search
                ? parts.map((part, index) => {
                      return (
                          <span
                              key={`${part.text}-${index}`}
                              className={clsx(
                                  part.highlight
                                      ? classes?.highlighted || "highlighted"
                                      : classes?.unHighlighted || "unHighlighted"
                              )}
                              style={{
                                  ...(part.highlight
                                      ? classes?.highlighted
                                          ? {}
                                          : styles.highlighted
                                      : classes?.unHighlighted
                                      ? {}
                                      : styles.unHighlighted),
                              }}
                          >
                              {part.text}
                          </span>
                      );
                  })
                : text}
        </>
    );
};

export const useHighlight = () => {
    const highlight = ({ text, search, classes }) => Highlight({ text, search, classes });

    return { highlight };
};
